import {
  getRedemptions,
  getRedemptionsByTicket
} from "@/services/redemption";
import store from "@/store";
import {
  formatProcessingTime,
 } from "@/common/helpers/ProductHelper";
import { ProductType } from "@/common/constant/ProductType";

const state = {
  redemptionList: null,
};

const getters = {
  redemptions: (state) => state.redemptionList,
};

const actions = {
  async getRedemptionList({ commit }) {
    try {
      store.commit("showLoading", true);
      const res = await getRedemptions();
      commit("getRedemptionList", res.data);
      store.commit("showLoading", false);
    } catch (error) {
      console.log(error);
    }
  },
  async getRemptionListByTicket({ commit }, { ticketId }) {
    try {
      const res = await getRedemptionsByTicket(ticketId);
      commit("getRedemptionsByTicket", res.data);
    } catch (error) {
      console.log(error);
    }
  }
};

const mutations = {
  getRedemptionList: (state, data) => {
    state.redemptionList = data.map((item) => {
      const product = item.product;

      if (product.type === ProductType.SERVICE) {
        item.formatProcessingTime = formatProcessingTime(product.type, item.processingTime);
      } else {
        item.formatProcessingTime = '-';
      }

      return item;
    });
  },
  getRedemptionsByTicket: (state, data) => { // NEED TEST THIS FLOW
    state.redemptionList = data.map((item) => {
      const product = item.product;

      if (product.type === ProductType.SERVICE) {
        item.formatProcessingTime = formatProcessingTime(product.type, item.processingTime);
      } else {
        item.formatProcessingTime = '-';
      }

      return item;
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
